<template>
  <div v-if="value[ingQueIndex]" class="lv-assignment-swiper">
    <DotLoading v-if="isLoading" />
    <div v-else class="lv-assignment-swiper__content-wrap">
      <div class="lv-assignment-swiper__content mb-20">
        <LvText h5 bold class="mb-40">{{ ingQueIndex + 1 }} / {{ value.length }}</LvText>
        <LvText h3 wrap>{{ value[ingQueIndex].title }}</LvText>
        <WsTextButton001
          v-if="value[this.ingQueIndex].remark"
          primary
          leading-icon="icon-light"
          class="mt-0 mb-60"
          @click="$_onOpenPopup('popup')"
        >
          {{ $t(btnTextLabel) }}
        </WsTextButton001>
      </div>
      <div v-if="_showAnswerInfo" class="lv-assignment-swiper__content mb-60">
        <LvText h5 class="mb-12">
          {{ $t(_answerValueTitle) }}
        </LvText>
        <LvText h4 class="mb-8"
          >{{ value[ingQueIndex].answerResult }}
          {{ value[ingQueIndex].unit ? value[ingQueIndex].unit : '' }}</LvText
        >
        <TextChip
          hasBg
          :color="value[ingQueIndex].answerRisk.color"
          :leadingIcon="value[ingQueIndex].answerRisk.icon"
          :textLabel="value[ingQueIndex].answerRisk.text"
        />
      </div>
      <div v-else-if="_isUserChecker" class="lv-assignment-swiper__content">
        <WsInputTextareaButton001
          v-if="value[ingQueIndex].quesType.value === 'text'"
          :value="value[ingQueIndex].answerValue"
          :style="{ width: '100%' }"
          placeholder="請輸入觀測內容"
          class="mt-20"
          @input="$_onInput($event, 'answerValue')"
        />
        <TimePicker
          v-else-if="value[ingQueIndex].quesType.value === 'date'"
          :value="value[ingQueIndex].answerValue"
          required
          type="datetime"
          rules="required"
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="YYYY-MM-DD 00:00:00"
          :style="{ width: '100%' }"
          @input="$_onInput($event, 'answerValue')"
        />
        <LvFlexBox v-else-if="value[ingQueIndex].quesType.value === 'num'">
          <StateInputButton
            :value="value[ingQueIndex].answerValue"
            type="Number"
            placeholder="請輸入觀測值"
            @input="$_onInput($event, 'answerValue')"
          />
          <LvText v-if="value[ingQueIndex].unit" class="ml-4">{{ value[ingQueIndex].unit }}</LvText>
        </LvFlexBox>
        <LvBtnList
          v-else
          :value="
            value[ingQueIndex].answerValue && Array.isArray(value[ingQueIndex].answerValue)
              ? value[ingQueIndex].answerValue[0]
              : null
          "
          big
          flexColUnderMd
          :btnList="$_setBtnList(value[ingQueIndex].optionList)"
          @click="$_onInput($event, 'option')"
        />
      </div>
      <div v-else class="lv-assignment-swiper__content mb-30">
        <LvText h2>{{ $t('尚未作答') }}</LvText>
      </div>
      <div class="lv-assignment-swiper__nav-btns">
        <div
          class="btn"
          :class="{ disabled: _isNeedAnswerRemark }"
          @click="$_onChangeQuesIndex('previous')"
        >
          <i class="icon-chevron-back" />
        </div>
        <div
          class="btn"
          :class="{ disabled: _isNeedAnswerRemark }"
          @click="$_onChangeQuesIndex('next')"
        >
          <i class="icon-chevron-forward" />
        </div>
      </div>
    </div>
    <div v-if="!isLoading && _showAnswerInfo" class="lv-assignment-swiper__answerer-wrap">
      <ListCard white noPadding>
        <ListCardItem row noPadding type="slot" title="答題者" class="mb-8">
          <template v-slot:slot>
            <LlAvatar
              :circleSize="22"
              :time="value[ingQueIndex].answerer.time"
              :textLabel="value[ingQueIndex].answerer.name"
              :subTextLabel="value[ingQueIndex].answerer.subTextLabel"
              :image="value[ingQueIndex].answerer.avatar ? value[ingQueIndex].answerer.avatar : ''"
            />
          </template>
        </ListCardItem>
        <ListCardItem
          v-if="value[ingQueIndex].lat && value[ingQueIndex].lng"
          row
          noPadding
          type="slot"
          title="答題位置"
          class="mb-8"
        >
          <template v-slot:slot>
            <WsTextButton001
              primary
              noPadding
              fontSizeMd
              @click="$_onClickLocation(value[ingQueIndex].lat, value[ingQueIndex].lng)"
            >
              {{ `${value[ingQueIndex].lat}, ${value[ingQueIndex].lng}` }}
            </WsTextButton001>
          </template>
        </ListCardItem>
        <ListCardItem
          v-if="value[ingQueIndex].ip"
          row
          noPadding
          type="text"
          title="IP"
          :textContent="value[ingQueIndex].ip"
        />
      </ListCard>
      <LvTextCard
        v-if="
          value[ingQueIndex].answerRemark ||
          (value[ingQueIndex].answerImages && value[ingQueIndex].answerImages.length)
        "
        :cardContent="value[ingQueIndex].answerRemark"
        class="mt-15"
      >
        <template v-slot:title>
          <LvText h5 bold class="mb-8">{{ $t('備註') }}</LvText>
        </template>
        <template v-slot:content>
          <LvText h6 class="mb-10">{{ value[ingQueIndex].answerRemark }}</LvText>
          <LvFileList
            v-if="value[ingQueIndex].answerImages && value[ingQueIndex].answerImages.length"
            outline
            twoItem
            nonBorderTop
            :marginTop="20"
            :value="value[ingQueIndex].answerImages"
            @go-to="$_onGoToFile($event)"
          />
        </template>
      </LvTextCard>
    </div>
    <InputListCard v-else-if="!isLoading && _isUserChecker">
      <div class="lv-assignment-swiper__answer-title mb-20">
        <LvText h5 bold class="mr-8"> <i class="icon-edit-pencil" />{{ $t('備註') }} </LvText>
        <LvText v-if="_isNeedAnswerRemark" h6 red>
          <i class="icon-warning" />{{ $t(_warningMessage) }}
        </LvText>
      </div>
      <div class="lv-assignment-swiper__answer-remark mb-10">
        <LvText h6>
          {{ $t('請寫下檢查當場處理情況、以及填報當場未能解決之問題。') }}
        </LvText>
        <LvUploadFileBtn
          multiple
          type="text"
          btnText="附件"
          :uploadModule="uploadModule"
          :selectedFileList="value[ingQueIndex].answerImages"
          @input="$_onInput($event, 'answerImages')"
        />
      </div>
      <WsInputTextareaButton001
        :value="value[ingQueIndex].answerRemark"
        :min-height="134"
        :placeholder="$t('輸入')"
        class="mb-20"
        @input="$_onInput($event, 'answerRemark')"
      />
      <div v-if="value[ingQueIndex].answerImages && value[ingQueIndex].answerImages.length > 0">
        <LvFileList
          narrow
          outline
          twoItem
          showDeleteBtn
          :marginTop="20"
          :module="uploadModule"
          :value="value[ingQueIndex].answerImages"
          @go-to="$_onGoToFile($event)"
          @delete-file="$_onDeleteImage($event)"
        />
      </div>
    </InputListCard>
    <div v-else-if="!isLoading" class="lv-assignment-swiper__answerer-wrap">
      <div class="lv-assignment-swiper__avatar-wrap">
        <LvText h4 lightGray class="mr-20">{{ $t('答題者') }}</LvText>
        <LlAvatar
          v-for="(checker, checkerIndex) in value[ingQueIndex].checkers"
          :key="checkerIndex"
          :circle-size="22"
          :image="checker.avatar ? checker.avatar : ''"
          :text-label="checker.name"
        />
      </div>
    </div>
    <PopUp :pop-up-active="isActive.popup" @click="$_onClosePopup('popup')">
      <ListCard is-table white no-padding big-title :title="$t(popupTitle)">
        <ListCardItem
          row
          is-table
          type="text"
          titleIcon="icon-light"
          :textContent="value[ingQueIndex].remark"
          :attaches="value[ingQueIndex].allAttaches"
          @go-to="$_onGoToFile($event)"
        />
      </ListCard>
    </PopUp>
  </div>
</template>
<script>
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';
import H_checklistAssignment from '@/helpers/checklistAssignment';

export default {
  props: {
    popupTitle: {
      type: String,
      default: '查核提示',
    },
    value: {
      type: Array,
    },
    quesIndex: {
      type: Number,
      default: 0,
    },
    btnTextLabel: {
      type: String,
      default: '查看合規標準',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    },
  },
  data() {
    return {
      isActive: {
        popup: false,
      },
      ingQueIndex: 0,
      quesList: [],
      isAnswerOrRemarkOrImgChanged: false,
    };
  },
  computed: {
    _riskLevelList() {
      return this.$store.state.model.checklistRiskLevelList;
    },
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _showAnswerInfo() {
      const q = this.value[this.ingQueIndex];
      if (!q || !q.answerer) return false;
      return q.isCompleted || q.answerer.id !== this._currentUser.id;
    },
    _isUserChecker() {
      if (!this.value[this.ingQueIndex].checkers) return false;
      return this.value[this.ingQueIndex].checkers.some(
        checker => checker.id === this._currentUser.id,
      );
    },
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _isHasAnswerValue() {
      return H_checklistAssignment.setIsHasAnswerValue(this.value[this.ingQueIndex]);
    },
    _answerRiskScore() {
      if (!this._isHasAnswerValue) return null;
      const { answerRisk } = this.value[this.ingQueIndex];
      return answerRisk ? answerRisk.score : null;
    },
    _isOptionNeedAnswerRemark() {
      if (!this._isHasAnswerValue) return false;
      return H_checklistAssignment.setIsOptionNeedAnswerRemark(this.value[this.ingQueIndex]);
    },
    _isNeedAnswerRemark() {
      return H_checklistAssignment.setIsNeedAnswerRemark(this.value[this.ingQueIndex]);
    },
    _warningMessage() {
      if (!this._isHasAnswerValue || !this._isNeedAnswerRemark) return;
      if (this._isOptionNeedAnswerRemark) return '此選項要求必填備註';
      const riskLevel = this._riskLevelList.find(
        risk => risk.type == 'question' && risk.score == this._answerRiskScore,
      );
      return `${this.$t('{item} 必須寫下備註', {
        item: riskLevel.text,
      })}`;
    },
    _attaches() {
      if (!this.value[this.ingQueIndex].attaches && !this.value[this.ingQueIndex].tempAttaches)
        return [];
      return [
        ...this.value[this.ingQueIndex].attaches,
        ...this.value[this.ingQueIndex].tempAttaches,
      ];
    },
    _answerValueTitle() {
      switch (this.value[this.ingQueIndex].quesType.value) {
        case 'date':
          return '觀測時間';
        case 'text':
          return '觀測內容';
        case 'num':
          return '觀測值';
        case 'single-choice':
          return '選項';
        default:
          return '';
      }
    },
  },
  watch: {
    quesIndex() {
      this.ingQueIndex = this.quesIndex;
    },
    value() {
      this.quesList = [...this.value];
    },
  },
  mounted() {
    this.quesList = [...this.value];
    this.ingQueIndex = this.quesIndex;
  },
  methods: {
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
    },
    $_onDeleteImage(index) {
      const _value = [...this.value];
      _value[this.ingQueIndex].answerImages.splice(index, 1);
      this.$emit('input', _value);
    },
    $_onChangeQuesIndex(type) {
      if (this._isNeedAnswerRemark) return;
      if (this.isAnswerOrRemarkOrImgChanged) this.$emit('call-answer-api', this.ingQueIndex);
      this.isAnswerOrRemarkOrImgChanged = false;
      if (
        (type === 'next' && this.ingQueIndex + 1 === this.value.length) ||
        (type === 'previous' && this.ingQueIndex === 0)
      ) {
        this.$emit('input', this.value);
        this.$emit('close');
        return;
      }
      this.ingQueIndex = type === 'next' ? this.ingQueIndex + 1 : this.ingQueIndex - 1;
      this.$emit('change-ques-index', this.ingQueIndex);
    },
    $_onInput($event, key) {
      const _value = [...this.value];
      const currentItem = _value[this.ingQueIndex];
      if (key === 'answerImages') {
        if (!$event || !$event.length) return;
        currentItem[key] = [...currentItem[key], ...$event];
      } else if (key === 'option') {
        currentItem.answerValue = [$event];
      } else {
        const prev = currentItem[key] == null ? '' : currentItem[key];
        const next = $event == null ? '' : $event;
        if (prev === next) return;
        currentItem[key] = $event;
      }
      this.$emit('input', _value);
      this.isAnswerOrRemarkOrImgChanged = true;
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    $_setBtnList(optionList) {
      if (!optionList || !optionList.length) return [];
      return optionList.map(
        ({
          id,
          answerSettingItem,
          commonChoice,
          hasSubOption,
          riskValue: score,
          requiredRemark,
          title: text,
          subOptionList,
        }) => {
          const option = {
            id,
            answerSettingItem,
            commonChoice,
            score,
            text,
            requiredRemark,
          };
          if (hasSubOption) {
            option.subList = subOptionList.map(
              ({
                id,
                answerSettingItem,
                commonChoice,
                riskValue: score,
                requiredRemark,
                title: text,
              }) => ({
                id,
                answerSettingItem,
                commonChoice,
                score,
                text,
                requiredRemark,
              }),
            );
          }
          return option;
        },
      );
    },
    $_onClickLocation(lat, lng) {
      const mapUrl = H_common.getMapUrl(lat, lng);
      window.open(mapUrl, '_blank');
    },
  },
};
</script>
